type Address = {
  street: string;
  houseNumber: number;
};

export const formatAddress = (address: Address) =>
  [address.street, address.houseNumber].filter(Boolean).join(' ');
